import type { CheckoutCatalog, CheckoutOffer } from '../types';
import { fetchMe, webPayCatalog, webPayChange, webPayCheckout } from './auth';
import { telegram } from './telegram';
export const checkoutAvailable = !telegram.isInside;
export const preferredCurrency = (): string => {
  const region = new Intl.Locale(navigator.language).maximize().region ?? '';
  const currencies: Record<string, string> = { US: 'usd', GB: 'gbp', CH: 'chf', AU: 'aud', NZ: 'nzd', CA: 'cad', SE: 'sek', NO: 'nok', DK: 'dkk', SG: 'sgd', JP: 'jpy', KR: 'krw', TW: 'twd', HK: 'hkd', CN: 'cny', IS: 'isk', PL: 'pln', CZ: 'czk', HU: 'huf', RO: 'ron', IL: 'ils', SA: 'sar', AE: 'aed', QA: 'qar', UA: 'uah', RU: 'rub', BY: 'byn' };
  return currencies[region] ?? 'eur';
};
export const loadCatalog = (): Promise<CheckoutCatalog> => webPayCatalog();
export async function submitCheckout(offer: CheckoutOffer, currency: string): Promise<boolean | { clientSecret: string; publishableKey: string }> {
  const me = await fetchMe();
  if (offer.kind === 'sub' && me?.super?.role === 'owner' && me.super.source === 'stripe') {
    await webPayChange(offer.product, offer.interval);
    return true;
  }
  const checkout = await webPayCheckout(offer.key, currency);
  if ('url' in checkout) { window.location.assign(checkout.url); return false; }
  return checkout;
}
